import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'

import {
  BatchCollectionMgmtRemovalListPageLoadResult,
  BatchCollectionMgmtRemovalListPageLoadResultFromJSON
} from '@/api/models/batch/BatchCollectionMgmtRemovalListPageLoadResult'
import {
  BatchCollectionMgmtRemovalListRequest,
  BatchCollectionMgmtRemovalListRequestToJSON
} from '@/api/models/batch/BatchCollectionMgmtRemovalListRequest'

export class BatchCollectionMgmtRemovalListApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchCollectionMgmtRemovalListPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchCollectionMgmtRemovalListPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createCollectionMgmtRemovalList(
    request: BatchCollectionMgmtRemovalListRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/collection-management/removal-list`,
      BatchCollectionMgmtRemovalListRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
